var iqiyi$1 = {
  getVersion: function getVersion() {
    var zhishi = navigator.userAgent.match(/knowledge\s*KnowledgeVersion\/([\d.]+)/i);
    var iqiyi = navigator.userAgent.match(/iqiyi\s*IqiyiVersion\/([\d.]+)/i);
    var version = '';
    if (zhishi) {
      version = zhishi[1];
    } else if (iqiyi) {
      version = iqiyi[1];
    }
    if (!version) {
      return null;
    }
    var tmp = version.split('.');
    var array = tmp.map(function (item) {
      if (Number(item) < 10) {
        return "0".concat(item);
      }
      return item;
    });
    return Number(array.join(''));
  },
  ready: function ready() {
    return new Promise(function (resolve, reject) {
      if (typeof iqiyi === 'undefined') {
        reject(new Error("ready error: iqiyi not found, please detect iqiyi sdk has been installed!"));
        return;
      }
      iqiyi.ready(function (result) {
        if (!result) {
          reject(new Error('ready error: iqiyi.ready'));
          return;
        }
        resolve();
      });
    });
  },
  init: function init() {
    return this.ready().then(function () {
      return new Promise(function (resolve, reject) {
        iqiyi.init(function (result) {
          if (result.result === 0) {
            reject(new Error('init error: iqiyi.init'));
            return;
          }
          var data = result.data;
          if (data.P00001 === '0') {
            data.P00001 = '';
          }
          resolve(data);
        });
      });
    });
  }
};

export default iqiyi$1;
